module.exports = __webpack_public_path__ + "static/img/m_name.4c0910e.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/kr/m_name.png
// module id = 2vKa
// module chunks = 7